module.exports = __webpack_public_path__ + "static/media/geolocalization.2c7e634f.svg";